import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const rootContainer = ReactDOM.createRoot(document.getElementById("root"));
rootContainer.render(<App />);